export default __webpack_public_path__ + "static/media/4.256dc0a6.png";